import { render, staticRenderFns } from "./detail-contracts.vue?vue&type=template&id=e8b4c44a&scoped=true"
import script from "./detail-contracts.vue?vue&type=script&lang=js"
export * from "./detail-contracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b4c44a",
  null
  
)

export default component.exports